<template>
  <div class="brandIncreasePage">
    <div class="banner">
      <img src="../../assets/images/brandIncrease_banner.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon3">
        <i class="iconfont icon-pinpaizichanpingtai"></i>
      </div>
      <div class="breadcrumb_item">辅助功能&内容管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">广告管理</div>
    </div>

    <div class="main_content">
      <div class="noData">
        <p>专业广告内容管理，建议请使用web版管理中心</p>
      </div>
    </div>

    <div class="fixd_button_btm flex-rowl" v-if="isShowTabbar">
      <!-- <div class="return-fixd"> -->
      <div class="item" @click="handleReturn">返回</div>
    </div>
    <!-- <Tabbar v-if="isShowTabbar"></Tabbar> -->
  </div>
</template>

<script>
import { getMenuAuthTwo, getBrandList, encryptstringadd } from "../../api/api";
// import Tabbar from "../../components/Tabbar.vue";
import { mapState } from "vuex";
export default {
  name: "aManageIndex",
  // components: {
  //   Tabbar,
  // },
  data() {
    return {
      isShowTabbar: true,
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      keyword: "",
      qyid: 0,
      qyguid: 0,

      dataList: [],
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    if (userInfo.qy) {
      this.qyguid = userInfo.qy.qyguid;
    } else {
      this.qyguid = 0;
    }
    this.roleId = userInfo.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.getMenuAuthTwo();
    this.init();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    // 搜索
    handleSearch() {
      this.init();
    },
    init() {
      let { keyword, qyguid } = this;
      getBrandList({ keyword, qyguid }).then((res) => {
        let dataNew = res;
        dataNew.forEach((v) => {
          if (v.logo && v.logo.indexOf("http") == -1) {
            v.logo = "/Upload/" + v.logo;
          }
        });
        // 按时间降序
        // dataNew.sort((a, b) => b.createdate.localeCompare(a.createdate));
        this.dataList = dataNew;
      });
    },

    handleReturn() {
      history.back();
    },
    handleGo(id) {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$toast("暂无权限");
        return;
      }

      if (id) {
        // this.$router.push({ path: "/brandIndex/brandDetail", query: { id } });
        this.encryptstringadd("brandDetail", { id });
      } else {
        // this.$router.push({ path: "/brandIndex/brandDetail" });
        this.encryptstringadd("brandDetail", "");
      }
    },
    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },
  },
};
</script>
<style lang="less" scoped>
.brandIncreasePage {
  padding-bottom: 400px;
  .input_box.search {
    padding: 0 30px 0 35px;
    margin-bottom: 30px;
    .search_btn {
      width: 60px;
    }
  }
  .input_tip {
    font-size: 14px;
    margin-bottom: 60px;
    color: #aaaaaa;
    .btn {
      margin-left: 30px;
      background: #6e5c86;
      color: #fff;
      padding: 0 15px;
      height: 40px;
      line-height: 40px;
      font-size: 12px;
      border-radius: 5px;
    }
  }
  .noData p {
    text-align: center;
    font-size: 28px;
    color: #aaaaaa;
    padding: 150px 0;
  }
  .item_card {
    width: 650px;
    margin: 0 auto 60px;
    padding: 45px 37px 100px;
    position: relative;
    border: 2px solid #dedede;
    border-radius: 30px;
    box-sizing: border-box;
    margin-bottom: 60px;
    .title {
      font-size: 30px;
      color: #404d6c;
      p {
        font-size: 22px;
        margin-top: 20px;
      }
    }
    .img {
      width: 250px;
      height: 250px;
      margin: 80px auto 50px;
      overflow: hidden;
      background: #fbf8ef;
      img {
        width: 100%;
      }
    }
    .txt1 {
      font-size: 26px;
      color: #404d6c;
      margin-bottom: 10px;
    }
    .txt2 {
      font-size: 26px;
      color: #444444;
      font-weight: bold;
      margin-bottom: 10px;
      span {
        font-size: 26px;
        color: #f40728;
        font-weight: 400;
      }
    }
    .edit {
      width: 200px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      background: #6e5c86;
      border-radius: 25px;
      font-size: 20px;
      color: #fff;
      position: absolute;
      bottom: 30px;
      right: 20px;
    }
  }
}
</style>